import { Box, Button } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

export const LoadMore = ({ hasNextPage, loadMore }) => {
    const { t } = useTranslation();
    return (
        <>
            { hasNextPage ? (
                <Box
                    p={ 4 }
                    textAlign="center"
                    onClick={ () => {
                        loadMore && loadMore();
                    } }
                >
                    <Button colorScheme="blue" variant="ghost">
                        { t("calls.loadMore") }
                    </Button>
                </Box>
            ) : null }
        </>
    );
};
